export default "__VITE_ASSET__CrCciUvt__"